import { render, staticRenderFns } from "./PostDetailModal.vue?vue&type=template&id=9b132124&scoped=true"
import script from "./PostDetailModal.vue?vue&type=script&lang=js"
export * from "./PostDetailModal.vue?vue&type=script&lang=js"
import style0 from "./PostDetailModal.vue?vue&type=style&index=0&id=9b132124&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b132124",
  null
  
)

export default component.exports